import { render, staticRenderFns } from "./UntappdDialog.vue?vue&type=template&id=4e462066&"
import script from "./UntappdDialog.vue?vue&type=script&lang=js&"
export * from "./UntappdDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports